<script>
import XLSX from 'xlsx'
import { saveAs } from 'file-saver/FileSaver'
import { toArrayBuffer } from "src/utils";
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'
import { USDLRegex } from 'src/utils/validators'
import SlDateTime from 'components/Shared/DatePicker'
const moment = require('moment')
import AwesomeMask from 'awesome-mask'
import SlStatePicker from 'components/Shared/StateAutocomplete'
import AddressVerifyChip from 'components/Shared/AddressVerifyChip'
import { pickAddress, isCheckable } from 'src/utils/addressVerification'

export default {
    components: {
        SlDateTime,
        SlStatePicker,
        AddressVerifyChip
    },
    props: ['validation'],
    directives: {
        'mask': AwesomeMask
    },
    created () {
    },
    mounted () {
        $(function () {
            $("#studentContainer .scrollable.has-students")
                .off("scroll")
                .on("scroll", function() {
                    $("#studentContainer .thead").css({
                        left: -$(this).scrollLeft()
                    })
                    $("#studentContainer .tbody-frozen").css({
                        top:  -$(this).scrollTop() + 60
                    })
                })
                .trigger("scroll")
        })
    },
    data () {
        let component = this
        return {
            genderOptions: this.$store.state.shared.genders,
            studentColumns: [
                { name: 'selected', label:'', align: 'left', width: 50 },
                { name: 'dlState', label: 'DL State', align: 'left', width: 115, required: true },
                { name: 'dl', label: 'Drivers License #', align: 'left', width: 150, required: true },
                { name: 'lastName', label: 'Last Name', align: 'left', width: 150, required: true },
                { name: 'firstName', label: 'First Name', align: 'left', width: 150, required: true },
                { name: 'middleName', label: 'M.I.', align: 'left', width: 75 },
                { name: 'address1', label: 'Address 1', align: 'left', width: 400, required: true },
                { name: 'address2', label: 'Apt/Unit/Floor', align: 'left', width: 150 },
                { name: 'city', label: 'City', align: 'left', width: 150, required: true },
                { name: 'stateId', label: 'State', align: 'left', width: 115, required: true },
                { name: 'zip', label: 'Zip Code', align: 'left', width: 110, required: true },
                { name: 'gender', label: 'Gender', align: 'left', width: 150, required: true },
                { name: 'dob', label: 'DOB', align: 'left', width: 140, required: true },
                { name: 'phone', label: 'Phone', align: 'left', width: 150 },
                { name: 'email', label: 'Email', align: 'left', width: 150 },
                { name: 'completedDate', label: 'Completed', align: 'left', width: 175, autoFillDate:true }
            ],
            addStudentLabel: 'Add Student',
            addButtonFocused: false,
            students: {},
            addingStudent: false
        }
    },
    computed: {
        ...mapGetters('classes', [
            'getAddEditClassOpenState',
            'dlStateAbbrev',
            'driversLicenseErrorMap'
        ]),
        ...mapGetters([
            'stateOptions',
        ]),
        ...mapState({
            selectedTab: s => s.classes.selectedTab,
            dateFormat: s => s.shared.formats.datetime,
            sessionInformation: s => s.classes.sessionInformation,
            classModalMaximized: s=> s.classes.classModalMaximized,
            canEdit: s => s.classes.canEdit,
            autoCompleteStudentDate: s=> s.classes.autoCompleteStudentDate,
            canRereportInd: s => s.classes.canRereportInd,
            rereportStudents: s => s.classes.sessionInformation.rereportStudents
        }),
        canRereport (){
            return !this.$p(['RECRUITER']) && this.sessionInformation.classStatus == 5
        },
        driversLicenseError () {
            const errorMessage = (this.dlStateAbbrev) ? USDLRegex[this.dlStateAbbrev].description.join(', ') : ''
            return errorMessage
        },
        classTotalStudents () { 
            return _.sumBy(this.sessionInformation.sessions,session => session.students.length)
        },
        selectedStudents () {
            let selectedIds  = []
            _.map(this.currentSessionOrFirst('Students').students, 
                (student,i) => {
                    if(student.selected === true){
                        selectedIds.push(i)
                    }
                })
            return selectedIds
        },
        showCopyButton () {
            return (this.sessionInformation.sessions.length > 1) && ((this.classTotalStudents - this.currentSession().students.length) > 0)
        },
        disableIfSync () {
            return (this.currentSession().syncStudents && !this.isFirstSession())
        },
        studentTitle () {
            return this.currentSession().syncStudents && this.currentSession(true) !== 0 ? 'Currently synced with first Session ' : ''
        },
        studentValidation () {
            return this.validation.sessionInformation.sessions.$each[this.currentSessionOrFirst('Students',true)].students.$each
        },
        isProcessed () {
            // actual reports happens only if class is PROCESSED already
            //return
            return true
        },
        canReprocessStudents(){
            let vm = this
            return ( vm.$p(['ADMIN']) && vm.sessionInformation.classStatus == 5 && vm.selectedStudents.length > 0 && vm.currentSession().students.length > 0)
        }
    },
    methods: {
        ...mapActions('classes',[
            'reprocessCertificates'
        ]),
        ...mapActions('addressVerification', {
            checkAddress: 'check'
        }),
        ...mapMutations('classes',[
            'addStudent',
            'updateStudentField',
            'removeSelectedStudents',
            'copyStudentsFromSession',
            'setCurrentStudentIndex',
            'setSessionStudentInformation',
            'setSessionRereportStudentInformation',
            'autocompleteAddressSessionStudentUpdate'
        ]),
        setSessionStudentInformationMethod(info){
            let vm = this,
                student = vm.validation.sessionInformation.sessions.$each[info.sessionIndex].students.$each[info.studentIndex]

            /**
             * Rereporting
             * Note: Only handle Rererporting flagging for Processed Classes.
             */
            let originalStudent = vm.rereportStudents[info.studentIndex],
                isNewYorkStudent = ((info.type == 'dlState' && info.value == 32) || student.$model.dlState == 32)
            if((vm.sessionInformation.classStatus == 5) && isNewYorkStudent){
                if(originalStudent && originalStudent[info.type] != undefined){
                    if(originalStudent[info.type] == info.value){
                        student[info.type].$reset()
                    }
                    else{
                        student[info.type].$touch()
                    }
                }
                else{
                    if(!originalStudent) vm.setSessionRereportStudentInformation({ id: student.$model.studentId, studentIndex: info.studentIndex, reset: true })
                    let currentValue = vm.currentSession('Students').students[info.studentIndex][info.type]
                    vm.setSessionRereportStudentInformation({ studentIndex: info.studentIndex, field: info.type, value: currentValue ? currentValue : '' })
                    student[info.type].$touch()
                }

                let isNoLongerNYStudent = (info.type == 'dlState' && info.value != 32)
                if((!student.$anyDirty && originalStudent) || isNoLongerNYStudent){
                    vm.setSessionRereportStudentInformation({ studentIndex: info.studentIndex, remove: true })
                }
            }
            vm.setSessionStudentInformation(info)
        },
        currentSession (findIndex) {
            var filter = findIndex === true ? "findIndex" : "find"
            return _[filter](this.sessionInformation.sessions, {value: this.sessionInformation.selected})
        },
        currentSessionOrFirst (type, returnSessionIndex) {
            let firstSession = this.sessionInformation.sessions[0]
            let syncType = this.currentSession()[`sync${type}`]
            if (returnSessionIndex) {
                return (syncType === true) ? 0 : this.currentSession(true)
            }
            return (syncType === true) ? firstSession : this.currentSession() 
        },
        isFirstSession () {
            return this.currentSession().label === this.sessionInformation.sessions[0].label
        },
        addLabel (isFocus) {
            this.addStudentLabel = (isFocus) ? 'Press Enter to Add!' : 'Add Student' 
        },
        onFocus () {
            if(this.currentStudentSlotsAvailable() == 0) return
            this.addLabel(true)
            this.addButtonFocused = true
        },
        onBlur () {
            this.addLabel()
            this.addButtonFocused = false
        },
        calculatedColumnWidth (width) {
            return width ? width+"px" : 'auto'
        },
        column (col) {
            return _.find(this.studentColumns, {name: col})
        },
        studentHasError (studentIndex, student) {
            
            // return (student.completedDate && !this.validateDate(student.completedDate)) || this.studentValidation[studentIndex].$invalid
            return this.studentValidation[studentIndex].$invalid
        },
        onAddStudent (sessionIndex) {
            let vm = this
            vm.addStudent(sessionIndex)
            //vm.$forceUpdate()
            setTimeout(function(){
                // let newStudentIndex = vm.currentSessionOrFirst('Students').students.length - 1
                // console.log(vm.$refs[`dlstateDropdown${newStudentIndex}`].$el)
                //vm.$refs[`dlstateDropdown${newStudentIndex}`].$el.focus()
                if(!vm.addingStudent){
                    vm.addingStudent = true
                    $("#studentContainer .tbody")
                        .find(".tr:last-child")
                        .find(".q-input input")[0].focus()
                    vm.addingStudent = false
                }
            })    
        },
        copyStudents (sessionIndex) {
            this.currentSession().syncStudents = false
            this.copyStudentsFromSession({current:this.currentSession(true),target:sessionIndex})
        },
        removeStudentsConfirmation(){
            let vm = this
            return vm.$q.dialog({
                title: `Remove Students`,
                message: `Remove ${vm.selectedStudents.length} selected Students? This action cannot be undone.`,
                noBackdropDismiss: true,
                ok: {
                    label: "Yes, I'm Sure.",
                    color: 'positive'
                },
                cancel: {
                    label: 'Cancel',
                    color: 'grey'
                }
            })
            .then(() => {
                vm.removeSelectedStudents({
                    session: vm.currentSessionOrFirst('Students',true),
                    students: vm.selectedStudents
                })
            })
        },
        reprocessStudentsMethod(){
            let vm = this
            vm.reprocessCertificates({
                session: vm.currentSessionOrFirst('Students',true),
                students: vm.selectedStudents
            })
        },
        onDropdownFocus (index, studentIndex, type) {
            let vm = this
            let dropdown = this.$refs[index][0]
            dropdown.show()
            if(type){
                let $filter = $(dropdown.$refs.filter.$el)
                    $filter.find("input").off("keyup").on("keyup", function(){
                        if(dropdown.visibleOptions.length === 1){

                            vm.setSessionStudentInformationMethod({
                                sessionIndex: vm.currentSession(true),
                                studentIndex,
                                type,
                                value: dropdown.visibleOptions[0].value
                            })

                            dropdown.hide()
                        }
                    })
            }
        },
        validateDate (date, required) {
            let formats = ['M-D-YYYY', 'M/D/YYYY','M.D.YYYY']
            let isValid = moment(date,formats,true).isValid()
            if (!isValid && !required && !date) {
                isValid = true
            }
            return (isValid) ? true : false
        },
        currentStudentSlotsAvailable(){
            let vm = this
            if(vm.currentSessionOrFirst('MaxStudents').maxStudents === null) return null

            return (Math.max(vm.currentSessionOrFirst('MaxStudents').maxStudents - vm.currentSessionOrFirst('Students').students.length,0))
        },
        formatDate(date){
            return date
        },
        dateAutocomplete(sessionIndex){
            let endDate = this.sessionInformation.sessions[sessionIndex].endDate;
            if(!endDate) return notify.create({message:"Session End Date is missing!", type:"negative"})
            let localDateString = moment(new Date(endDate)).format('MM/DD/YYYY')

            for(var i=0;i<this.sessionInformation.sessions[sessionIndex].students.length;i++){
                let studentCompletedDate = this.sessionInformation.sessions[sessionIndex].students[i].completedDate
                if(!studentCompletedDate || studentCompletedDate == 'Invalid date'){
                    this.setSessionStudentInformationMethod({
                        sessionIndex: this.currentSession(true),
                        studentIndex: i,
                        type: 'completedDate',
                        value: localDateString
                    })
                }
            }    
        },
        onDLStateSearch(s, done, index) {
            const vm = this
            const results = this.stateOptions.filter(state => { 
                return vm._.startsWith(vm._.toLower(state.label), vm._.toLower(s))
            })
            if(results.length === 1) {
                this.onSelectDLState(results[0], index)
                this.$refs[`dlStateAutoComplete${index}`][0].hide()
            } 
            done(results)
        },
        onSelectDLState(selectedState, index) {
            console.log('selectedState', selectedState);
            this.setSessionStudentInformationMethod({
                sessionIndex: this.currentSession(true),
                studentIndex: index,
                type: 'dlState',
                value: selectedState.value
            })
            this.setSessionStudentInformation({
                sessionIndex: this.currentSession(true),
                studentIndex: index,
                type: 'dlStateName',
                value: selectedState.label
            })
            this.$refs[`dlInput${index}`][0].focus()
        },
        onClearDLState (index) {
            this.setSessionStudentInformationMethod({
                sessionIndex: this.currentSession(true),
                studentIndex: index,
                type: 'dlState',
                value: null
            })
            this.setSessionStudentInformation({
                sessionIndex: this.currentSession(true),
                studentIndex: index,
                type: 'dlStateName',
                value: ''
            })
        },
        onStateSearch(s, done, index) {
            const vm = this
            const results = this.stateOptions.filter(state => { 
                return vm._.startsWith(vm._.toLower(state.label), vm._.toLower(s))
            })
            if(results.length === 1) {
                this.onSelectState(results[0], index)
                this.$refs[`stateAutoComplete${index}`][0].hide()
            } 
            done(results)
        },
        onSelectState(selectedState, index) {
            this.setSessionStudentInformationMethod({
                sessionIndex: this.currentSession(true),
                studentIndex: index,
                type: 'stateId',
                value: selectedState.value
            })
            this.setSessionStudentInformation({
                sessionIndex: this.currentSession(true),
                studentIndex: index,
                type: 'stateName',
                value: selectedState.label
            })
            this.$refs[`zip${index}`][0].focus()
        },
        placeChange(place, studentIndex) {
            this.autocompleteAddressSessionStudentUpdate({
                sessionId: this.currentSessionOrFirst("Student", true),
                place,
                studentIndex,
                stateOptions: this.stateOptions
            })
            // Helps with tabbing
            this.$refs[`address2${studentIndex}`][0].focus()
        },
        /**
         * Check a row's address with Google once focus has left its address
         * fields, so tabbing from Address 1 to City to Zip asks once, for the
         * finished address, rather than for every partial one on the way.
         *
         * Only a complete address is checked here (Zip included, or a Zip
         * typed last would cost a second check). Save checks whatever is left.
         * The store skips an address that already has a result.
         */
        onAddressBlur(studentIndex) {
            setTimeout(() => {
                const stillInRow = $(document.activeElement)
                    .closest(`[data-address-row="${studentIndex}"]`).length > 0
                if (stillInRow) return

                const student = this.currentSessionOrFirst('Students').students[studentIndex]
                if (!student) return

                const address = pickAddress(student)
                if (!isCheckable(address) || !String(address.zip || '').trim()) return

                this.checkAddress({ address })
            }, 200)
        },
        /**
         * The user accepted Google's corrected address from the FIX chip.
         * Written through the same path as typing so the row is marked dirty
         * and saved; the store already holds a verified result for it.
         */
        onAcceptAddress(studentIndex, suggestion) {
            const sessionIndex = this.currentSession(true)
            ;['address1', 'address2', 'city', 'stateId', 'zip'].forEach(type => {
                this.setSessionStudentInformationMethod({
                    sessionIndex,
                    studentIndex,
                    type,
                    value: suggestion[type] || ''
                })
            })
            const state = this._.find(this.stateOptions, { value: suggestion.stateId })
            this.setSessionStudentInformation({
                sessionIndex,
                studentIndex,
                type: 'stateName',
                value: state ? state.label : ''
            })
        },
        $touch({ sessionIndex, studentIndex, type}){
            let vm = this
            console.log(vm.sessionInformation.classStatus)
            if( vm.sessionInformation.classStatus != 5 ){
                    vm.validation.sessionInformation.sessions.$each[sessionIndex].students.$each[studentIndex].$touch()
                    console.log('$touch', vm.validation.sessionInformation.sessions.$each[sessionIndex].students.$each[studentIndex][type].$error)
            }
        },
        exportStudents(){
            const vm = this
            let studentData = vm.currentSessionOrFirst('Students').students
            console.log(studentData)
            studentData = studentData.map(s => {
                return {
                    'First Name': s.firstName,
                    'Middle Name' : s.middleName,
                    'Last Name' : s.lastName,
                    'Address 1': s.address1,
                    'Apt/Unit/Floor': s.address2,
                    'City': s.city,
                    'State': s.stateName,
                    'Zip': s.zip,
                    'Completed': s.completedDate,
                    'Drivers License' : s.dl,
                    'DL State': s.dlStateName,
                    'DOB': s.dob,
                    'Phone' : s.phone,
                    'Email': s.email,
                }
            })
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(studentData)
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Export')
            let sheetData = XLSX.write(workbook, { type: 'array', bookType: 'xlsx'})
            saveAs(
                new Blob([sheetData], {
                    type: "application/octet-stream"
                }),
                "StudentExport.xlsx"
            )
        }
    }
}
</script>

<template>
    <div id="studentTable">
        <div class="scrollable no-students" v-show="currentSessionOrFirst('Students').students.length === 0">
            <h6 v-if="currentSession().syncStudents && !isFirstSession()" style="text-align:center">No Students in First Session.<br><span style="font-size:10px;">(Currently Synced with First Session)</span></h6>
            <h6 v-if="!currentSession().syncStudents || isFirstSession()">No Students for this Session.</h6>
            <span v-show="canEdit && (!currentSession().syncStudents || isFirstSession())" @click="onAddStudent(currentSessionOrFirst('Students',true))" class="label bg-primary">Please add a Student!</span>
        </div>
        <div class="scrollable has-students" v-show="currentSessionOrFirst('Students').students.length > 0">
            <div class="thead">
                <div v-for="(column, index) in studentColumns" :key="index" :style="{'text-align':column.align, flex: '0 0 ' + calculatedColumnWidth(column.width), 'max-width': calculatedColumnWidth(column.width)}">
                    <span>{{column.label}}<span v-if="column.required">*</span></span>
                        <span v-if="column.autoFillDate">
                            <q-btn
                                class="auto-fill-date"
                                color="primary"
                                size="sm"
                                :disable="!canEdit || (currentSessionOrFirst('Students').syncStudents && !isFirstSession())"
                                label="Fill" @click.native="dateAutocomplete(currentSessionOrFirst('Students',true))">
                                    <q-tooltip v-if="currentStudentSlotsAvailable() == 0"
                                        anchor="top middle"
                                        self="bottom middle"
                                        :offset="[10, 10]">
                                       All unedited Completed On fields will be set to the current End Date
                                    </q-tooltip>                                
                            </q-btn>                         
                        </span>
                </div>
            </div>
            <div class="tbody-frozen">
                <div class="tr"
                    :key="index"
                    :title="studentTitle"
                    :class="{
                        'has-error': studentHasError(index,student),
                        'selected' : student.selected,
                        'rereport' : studentValidation[index].$anyDirty && sessionInformation.classStatus == 5 && student.dlState == 32
                    }"
                    v-for="(student, index) in currentSessionOrFirst('Students').students">
                    <div
                        class="td"
                        :style="{flex: '0 0 ' + column('selected').width +'px','max-width': column('selected').width +'px'}">
                        <div >
                            <q-checkbox
                                :disable="disableIfSync || !canEdit"
                                v-model="student.selected" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="tbody">
                <div class="tr"
                    :key="index"
                    :title="studentTitle"
                    :class="{
                        'has-error': studentHasError(index,student),
                        'selected' : student.selected,
                        'rereport' : studentValidation[index].$anyDirty && sessionInformation.classStatus == 5 && student.dlState == 32
                    }"                    
                    v-for="(student, index) in currentSessionOrFirst('Students').students">
                    <div class="td" :style="{flex: '0 0 ' + column('dlState').width +'px','max-width': column('dlState').width +'px'}"><div :style="{width: column('dlState').width +'px'}">                        
                        <!-- <q-field
                            :error="studentValidation[index].dlState.$error"
                            error-label="Required">
                            <q-input :value="student.dlStateName"
                                    clearable
                                    :disable="(disableIfSync || !canEdit) && !canRereport"
                                    @clear="setSessionStudentInformationMethod({
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'dlState',
                                        value: null
                                    })"
                                    :after="[
                                        {icon: 'flag', condition: studentValidation[index].dlState.$invalid },
                                        {icon: 'fa fa-check', condition: !studentValidation[index].dlState.$invalid}
                                    ]"
                                    @blur="$touch({ 
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'dlState'
                                    })">
                                <sl-state-picker 
                                    :selected="val=> setSessionStudentInformationMethod({
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'dlState',
                                        value: val
                                    })" />
                            </q-input>
                        </q-field> -->
                        <q-field>
                            <!-- <q-autocomplete 
                                ref="ClassAutoComplete"
                                :debounce="500"
                                :max-results="maxResults"
                                @search="onSearch"
                                @selected="onSelect"
                            /> -->
                            <q-input
                                :after="[
                                
                                ]"
                                placeholder="Search for DL State"
                                :disable="!canEdit"
                                :clear-value="null"
                                clearable
                                @clear="(item) => onClearDLState(index)"
                                v-model="student.dlStateName">
                                <q-autocomplete 
                                    :ref="'dlStateAutoComplete'+index"
                                    @selected="(item) => onSelectDLState(item, index)"
                                    @search="(s, done) => onDLStateSearch(s, done, index)"
                                />
                            </q-input>
                            <!-- <q-select
                                :disable="(disableIfSync || !canEdit) && !canRereport"
                                :ref="'dlstateDropdown'+index" 
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].dlState.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].dlState.$invalid}
                                ]"
                                @focus="onDropdownFocus('dlstateDropdown'+index, index, 'dlState')"
                                filter
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'dlState'
                                })"
                                autofocus-filter
                                :options="stateOptions"
                                @change="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'dlState',
                                    value: val
                                })"
                                :value="student.dlState" /> -->
                        </q-field>
                    </div></div>
                    <div class="td" :style="{flex: '0 0 ' + column('dl').width +'px'}"><div :style="{width: column('dl').width +'px'}">
                        <q-field 
                            :error="studentValidation[index].dl.$error"
                            :error-label="driversLicenseErrorMap[index]"
                        >
                            <q-input 
                                :ref="'dlInput'+index"
                                :disable="disableIfSync || !canEdit"
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'dl',
                                    value: val
                                })"
                                @keydown="e => { if (e.key === '-') e.preventDefault() }"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'dl'
                                })"
                                :value="student.dl"
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].dl.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].dl.$invalid}
                                ]"
                            />
                        </q-field>
                    </div></div>                                        
                    <div class="td" :style="{flex: '0 0 ' + column('lastName').width +'px'}"><div :style="{width: column('lastName').width +'px'}">
                        <q-field
                            :error="studentValidation[index].lastName.$error"
                            error-label="Required"
                        >
                            <q-input 
                                :disable="disableIfSync || !canEdit"
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'lastName',
                                    value: val
                                })"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'lastName'
                                })"
                                :value="student.lastName"
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].lastName.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].lastName.$invalid}
                                ]"
                            />
                        </q-field>
                    </div></div>
                    <div class="td" :style="{flex: '0 0 ' + column('firstName').width +'px'}"><div :style="{width: column('firstName').width +'px'}">
                        <q-field
                            :error="studentValidation[index].firstName.$error"
                            error-label="Required"
                        >
                            <q-input 
                                :disable="disableIfSync || !canEdit"
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'firstName',
                                    value: val
                                })"
                                :value="student.firstName"
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].firstName.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].firstName.$invalid}
                                ]"
                            />
                        </q-field>
                    </div></div>
                    <div class="td" :style="{flex: '0 0 ' + column('middleName').width +'px'}"><div :style="{width: column('middleName').width +'px'}">
                        <q-field>
                            <q-input 
                                :disable="disableIfSync || !canEdit"
                                :value="student.middleName" 
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'middleName',
                                    value: val
                                })"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'middleName'
                                })"
                            />
                        </q-field>
                    </div></div>
                    <div class="td" :data-address-row="index" :style="{flex: '0 0 ' + column('address1').width +'px'}"><div class="address1-cell" :style="{width: column('address1').width +'px'}">
                        <q-field
                            class="address1-field"
                            :error="studentValidation[index].address1.$error"
                            error-label="Required"
                        >
                            <q-input 
                                :disable="disableIfSync || !canEdit"
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'address1',
                                    value: val
                                })"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'address1'
                                }); onAddressBlur(index)"
                                :value="student.address1"
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].address1.$invalid }
                                ]"
                                v-places-autocomplete="(place) => placeChange(place, index)"
                                autocomplete="new-password"
                            />
                        </q-field>
                        <address-verify-chip
                            :address="{
                                address1: student.address1,
                                address2: student.address2,
                                city: student.city,
                                stateId: student.stateId,
                                zip: student.zip
                            }"
                            :disable="disableIfSync || !canEdit"
                            @accept="suggestion => onAcceptAddress(index, suggestion)"
                        />
                    </div></div>
                    <div class="td" :data-address-row="index" :style="{flex: '0 0 ' + column('address2').width +'px'}"><div :style="{width: column('address2').width +'px'}">
                      <q-input
                          :disable="disableIfSync || !canEdit"
                          :ref="'address2'+index"
                          @input="val=> setSessionStudentInformationMethod({
                              sessionIndex: currentSession(true),
                              studentIndex: index,
                              type: 'address2',
                              value: val
                          })"
                          @blur="$touch({
                              sessionIndex: currentSession(true),
                              studentIndex: index,
                              type: 'address2'
                          }); onAddressBlur(index)"
                          :value="student.address2"
                      />
                    </div></div>
                    <div class="td" :data-address-row="index" :style="{flex: '0 0 ' + column('city').width +'px'}"><div :style="{width: column('city').width +'px'}">
                        <q-field
                            :error="studentValidation[index].city.$error"
                            error-label="Required"
                        >
                            <q-input 
                                :disable="disableIfSync || !canEdit"
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'city',
                                    value: val
                                })"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'city'
                                }); onAddressBlur(index)"
                                :value="student.city"
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].city.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].city.$invalid}
                                ]"
                                autocomplete="new-password"
                            />
                        </q-field>
                    </div></div>
                    <div class="td" :data-address-row="index" :style="{flex: '0 0 ' + column('stateId').width +'px'}"><div :style="{width: column('stateId').width +'px'}">
                        <!-- <q-field
                            :error="studentValidation[index].stateId.$error"
                            error-label="Required">
                            <q-input :value="student.stateName"
                                    clearable
                                    :disable="(disableIfSync || !canEdit) && !canRereport"
                                    @clear="setSessionStudentInformationMethod({
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'stateId',
                                        value: null
                                    })"
                                    :after="[
                                        {icon: 'flag', condition: studentValidation[index].stateId.$invalid },
                                        {icon: 'fa fa-check', condition: !studentValidation[index].stateId.$invalid}
                                    ]"
                                    @blur="$touch({ 
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'stateId'
                                    })">
                                <sl-state-picker 
                                    :selected="val=> setSessionStudentInformationMethod({
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'stateId',
                                        value: val
                                    })" />
                            </q-input>
                        </q-field> -->
                        <q-field
                            :error="studentValidation[index].stateId.$error"
                            error-label="Required"
                        >
                            <q-input
                                :after="[
                                {icon: 'flag', condition: studentValidation[index].stateId.$invalid },
                                {icon: 'fa fa-check', condition: !studentValidation[index].stateId.$invalid}
                                ]"
                                placeholder="State"
                                :disable="!canEdit"
                                :clear-value="null"
                                clearable
                                @blur="onAddressBlur(index)"
                                v-model="student.stateName">
                                <q-autocomplete 
                                    :ref="'stateAutoComplete'+index"
                                    @selected="(item) => onSelectState(item, index)"
                                    @search="(s, done) => onStateSearch(s, done, index)"
                                />
                            </q-input>
                            <!-- <q-select 
                                :disable="disableIfSync || !canEdit" :ref="'stateDropdown'+index" 
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].stateId.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].stateId.$invalid}
                                ]"
                                @focus="onDropdownFocus('stateDropdown'+index, index, 'stateId')"
                                filter
                                autofocus-filter
                                :options="stateOptions"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'stateId'
                                })"
                                @change="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'stateId',
                                    value: val
                                })"
                                :value="student.stateId"
                                autocomplete="new-password"
                            /> -->
                        </q-field>
                    </div></div>
                    <div class="td" :data-address-row="index" :style="{flex: '0 0 ' + column('zip').width +'px'}"><div :style="{width: column('zip').width +'px'}">
                        <q-field
                            :error="studentValidation[index].zip.$error"
                            error-label="Required"
                        >
                            <q-input 
                                :disable="disableIfSync || !canEdit" 
                                :ref="'zip'+index"
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'zip',
                                    value: val
                                })"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'zip'
                                }); onAddressBlur(index)"
                                :value="student.zip"
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].zip.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].zip.$invalid}
                                ]"
                                autocomplete="new-password"
                            />
                        </q-field>
                    </div></div>
                    <div class="td" :style="{flex: '0 0 ' + column('gender').width +'px'}"><div :style="{width: column('gender').width +'px'}">
                        <q-field
                            :error="studentValidation[index].gender.$error"
                            error-label="Required">
                            <q-select
                                filter
                                :value="student.gender"
                                :options="genderOptions"
                                :disable="disableIfSync || !canEdit"
                                :ref="'genderDropdown'+index"
                                :after="[
                                    {icon: 'flag', condition: studentValidation[index].gender.$invalid },
                                    {icon: 'fa fa-check', condition: !studentValidation[index].gender.$invalid}
                                ]"
                                @blur="$touch({ 
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'gender'
                                })"
                                @focus="onDropdownFocus('genderDropdown' + index, index, 'gender')"
                                @change="val => 
                                        setSessionStudentInformationMethod({
                                            sessionIndex: currentSession(true),
                                            studentIndex: index,
                                            type: 'gender',
                                            value: val
                                        })"
                                />                                
                        </q-field>
                    </div></div>
                    <div class="td dob-field" :style="{flex: '0 0 ' + column('dob').width +'px'}">
                        <div :style="{width: column('dob').width +'px'}">
                            <q-field
                                :error="studentValidation[index].dob.$error"
                                error-label="MM/DD/YYYY"
                            >
                                <q-input
                                    :value="student.dob"
                                    :disable="disableIfSync || !canEdit"
                                    :after="[
                                        {icon: 'flag', condition: studentValidation[index].dob.$invalid },
                                        {icon: 'fa fa-check', condition: !studentValidation[index].dob.$invalid}
                                    ]"
                                    @blur="$touch({ 
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'dob'
                                    })"
                                    @keyup.stop="
                                    setSessionStudentInformationMethod({
                                        justSync: true,
                                        sessionIndex: currentSession(true),
                                        studentIndex: index,
                                        type: 'dob',
                                        value: $event.target.value
                                    });
                                    updateStudentField({
                                        field: 'dob',
                                        new: $event.target.value,
                                        session: currentSessionOrFirst('Students',true),
                                        index: index
                                    });"
                                />
                            </q-field>
                        </div>
                    </div>
                    <div class="td" :style="{flex: '0 0 ' + column('phone').width +'px'}"><div :style="{width: column('phone').width +'px'}">
                        <q-field>
                            <q-input 
                                :disable="disableIfSync || !canEdit"
                                @input="val=> setSessionStudentInformationMethod({
                                    sessionIndex: currentSession(true),
                                    studentIndex: index,
                                    type: 'phone',
                                    value: val
                                })"
                                :value="student.phone"
                                type="tel"
                                v-mask="'999-999-9999'" />
                        </q-field>
                    </div></div>
                    <div class="td" :style="{flex: '0 0 ' + column('email').width +'px'}"><div :style="{width: column('email').width +'px'}">
                        <q-field>
                            <q-input :disable="disableIfSync || !canEdit" v-model="student.email" />
                        </q-field>
                    </div></div>
                    <div class="td" :style="{flex: '0 0 ' + column('completedDate').width +'px'}">
                        <div :style="{width: column('completedDate').width +'px'}">
                            <q-field
                            error-label="Invalid Date">
                                <sl-date-time
                                    :disable="disableIfSync || !canEdit"
                                    :value="student.completedDate"
                                    @keyup.stop="(newVal)=> {
                                        
                                        setSessionStudentInformationMethod({
                                            sessionIndex: currentSession(true),
                                            studentIndex: index,
                                            type: 'completedDate',
                                            value: $event.target.value
                                        });
                                        updateStudentField({
                                            field: 'completedDate',
                                            new: $event.target.value,
                                            session: currentSessionOrFirst('Students',true),
                                            index: index
                                        })
                                    }"
                                    type="date" 
                                />
                            </q-field>
                        </div>
                    </div>
                </div>
            </div> <!-- tbody -->
        </div>
        <div class="tfooter" v-if="canEdit">
            <q-btn
                color="primary"
                :class="{'text-primary': !addButtonFocused,'text-positive': addButtonFocused}"
                outline
                :disable="disableIfSync || currentStudentSlotsAvailable() == 0"
                v-show="!disableIfSync && canEdit"
                @focus.native="onFocus(true)"
                @blur.native="onBlur()"
                @click="onAddStudent(currentSessionOrFirst('Students',true))">
                {{addStudentLabel}}
                <q-tooltip v-if="currentStudentSlotsAvailable() == 0"
                    anchor="top middle"
                    self="bottom middle"
                    :offset="[10, 10]">
                    Max Students Reached!
                </q-tooltip>
            </q-btn>
            <q-btn
                @click="exportStudents()"
                v-if="currentSession().students.length > 0"
                outline 
                icon="fa fa-cloud-download"
                color="green">
                &nbsp;Export
            </q-btn>
            <q-btn
                @click="removeStudentsConfirmation()"
                v-if="selectedStudents.length > 0 && currentSession().students.length > 0"
                :disable="disableIfSync"
                v-show="!disableIfSync && canEdit"
                outline
                color="negative">
                Remove Selected
            </q-btn>
            <div class="right">
                
                <q-btn icon="refresh" v-if="canReprocessStudents" outline color="purple" @click.native="reprocessStudentsMethod(selectedStudents)">Reprocess Certificates</q-btn>
                <span class="sync-label" v-if="currentSessionOrFirst('Students').maxStudents">
                    ({{currentStudentSlotsAvailable()}}/{{currentSessionOrFirst('Students').maxStudents}}) Slots Available
                </span>
                <span class='sync-label' v-show="!isFirstSession() && canEdit"><q-checkbox :disable="!canEdit" v-model="currentSession().syncStudents"/> <span>Sync with First Session</span></span>
                <q-btn-dropdown
                    v-show="showCopyButton && canEdit"
                    label="Copy From.."
                    outline
                    color="grey">
                    <q-list link>
                        <q-item
                            v-if="session.label != currentSession().label && session.students.length > 0"
                            v-for="(session, index) in sessionInformation.sessions"
                            :key="index"
                            v-close-overlay
                            @click.native="copyStudents(index)">
                            <q-item-main>
                                {{session.label}}
                            </q-item-main>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
            </div>
        </div>
        <div class="tfooter" v-else>            
            <q-btn
                @click="exportStudents()"
                v-if="currentSession().students.length > 0"
                outline 
                icon="fa fa-cloud-download"
                color="green">
                &nbsp;Export
            </q-btn>
        </div>
    </div>
</template>

<style lang="stylus">
    @import '~variables'
    #studentTable .address1-cell
        display flex
        align-items center
        gap 6px
        .address1-field
            flex 1 1 auto
            min-width 0
    #studentContainer
        position absolute 
        top 0
        left 0
        right 0
        bottom 0
        overflow hidden
    #studentTable
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        display flex
        flex-direction column
        .scrollable
            flex-grow 1
            overflow auto
            margin-top 60px
            z-index 2
            &.no-students
                margin-top 0
                display flex
                vertical-align middle
                align-items center 
                justify-content center
                flex-direction column
                h6
                    margin-bottom 20px
        .thead
            top 0
            position absolute
            white-space nowrap
            display flex
            width 2035px
            z-index 101
            background #fff
            > div
                background #fff
                display inline-block
                padding 20px 15px
                border-bottom 1px solid border-color
                vertical-align bottom
        .tbody
            padding-left 50px
            .tr
                display flex
                white-space nowrap
                width 1985px
                position relative                
                &.has-error
                    .td
                        > div
                            background #fff6f6 !important
                            height 77px
                &.rereport
                    .td
                        > div
                            background #f4ddf7 !important
                &.selected 
                    .td 
                        > div
                            background #ecf2ff
                    &.has-error
                        .td > div
                            background #e2e5ff !important
                .td
                    display inline-block
                    border-bottom 1px solid border-color                    
                    > div
                        padding 10px 15px
                        height 58px
                        .q-field-content
                            padding 0
        .tbody-frozen
            position absolute
            //height 100%
            bottom 90px
            background #fff
            top 59px
            z-index 99
            .tr 
                display flex
                background #fff
                &.has-error
                    background #ffdbdb !important
                    > div
                        height 78px
                &.rereport
                    background #ca97d0 !important
                &.selected 
                    background #d1dfff
                .td
                    border-bottom 1px solid border-color
                    border-right 1px solid border-color
                    > div
                        padding 19px 15px
                        height 58px
        
        .tfooter
            border-top 1px solid border-color
            padding 12px 30px
            position relative
            z-index 9
            background #fff
            .right
                float right
                .sync-label
                    input
                        vertical-align middle
                        display inline-block
            button
                margin-right 7px
                &:last-child 
                    margin-right 0
        .q-field-with-error
            .material-icons
                color $negative !important
        .auto-fill-date
            font-size 10px
            width 48px
            border-radius 5px
            margin-left 10px
            padding 4px
</style>
